module.exports = __webpack_public_path__ + "static/media/9-normal.bb94aedc.png";